import React, { memo } from 'react'

function FormStoreMultiplier(props) {
    const { formik, show } = props
    return (
        <React.Fragment>
            <div className={`st-form st-form-with-label-left no-arrows d-flex flex-wrap align-items-center ${((formik.touched.brand_multiplier || formik.touched.brand_multiplier_type) && (formik.errors.brand_multiplier || formik.errors.brand_multiplier_type)) ? "has-msg msg-error" : ""}`}>
                <label>
                    Brand Multiplier
                    <span className="required">*</span>
                </label>

                <div className="media-body st-form-input-container">
                    <div className="st-form-inline-input-select position-relative no-min-width mb-0 d-flex align-items-center">
                        <input
                            type="number"
                            className="st-fs-15"
                            placeholder="0"
                            id="brand_multiplier"
                            name="brand_multiplier"
                            {...formik.getFieldProps('brand_multiplier')}

                        />
                        <select
                            // value={mT}
                            id="brand_multiplier_type"
                            name="brand_multiplier_type"
                            {...formik.getFieldProps('brand_multiplier_type')}

                        >
                            <option value="fixed">$</option>
                            <option value="percent">%</option>
                        </select>
                        {
                            ((formik.touched.brand_multiplier || formik.touched.brand_multiplier_type) && (formik.errors.brand_multiplier || formik.errors.brand_multiplier_type)) && (
                                <div className="st-form-msg position-absolute">
                                    <p className="st-fs-12">{formik.errors.brand_multiplier || formik.errors.brand_multiplier_type}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            <div className={`st-form st-form-with-label-left no-arrows d-flex flex-wrap align-items-center ${((formik.touched.category_multiplier || formik.touched.category_multiplier_type) && (formik.errors.category_multiplier || formik.errors.category_multiplier_type)) ? "has-msg msg-error" : ""}`}>
                <label>
                    Category Multiplier
                    <span className="required">*</span>
                </label>

                <div className="media-body st-form-input-container">

                    <div className="st-form-inline-input-select position-relative no-min-width mb-0 d-flex align-items-center">
                        <input
                            type="number"
                            className="st-fs-15"
                            placeholder="0"
                            id="category_multiplier"
                            name="category_multiplier"
                            {...formik.getFieldProps('category_multiplier')}

                        />
                        <select
                            // value={mT}
                            id="category_multiplier_type"
                            name="category_multiplier_type"
                            {...formik.getFieldProps('category_multiplier_type')}

                        >
                            <option value="fixed">$</option>
                            <option value="percent">%</option>
                        </select>
                        {
                            ((formik.touched.category_multiplier || formik.touched.category_multiplier_type) && (formik.errors.category_multiplier || formik.errors.category_multiplier_type)) && (
                                <div className="st-form-msg position-absolute">
                                    <p className="st-fs-12">{formik.errors.category_multiplier || formik.errors.category_multiplier_type}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            <div className={`st-form st-form-with-label-left no-arrows d-flex flex-wrap align-items-center ${((formik.touched.product_multiplier || formik.touched.product_multiplier_type) && (formik.errors.product_multiplier || formik.errors.product_multiplier_type)) ? "has-msg msg-error" : ""}`}>
                <label>
                    Product Multiplier
                    <span className="required">*</span>
                </label>

                <div className="media-body st-form-input-container">

                    <div className="st-form-inline-input-select position-relative no-min-width mb-0 d-flex align-items-center">
                        <input
                            type="number"
                            className="st-fs-15"
                            placeholder="0"
                            id="product_multiplier"
                            name="product_multiplier"
                            {...formik.getFieldProps('product_multiplier')}

                        />
                        <select
                            id="product_multiplier_type"
                            name="product_multiplier_type"
                            {...formik.getFieldProps('product_multiplier_type')}

                        >
                            <option value="fixed">$</option>
                            <option value="percent">%</option>
                        </select>
                        {
                            ((formik.touched.product_multiplier || formik.touched.product_multiplier_type) && (formik.errors.product_multiplier || formik.errors.product_multiplier_type)) && (
                                <div className="st-form-msg position-absolute">
                                    <p className="st-fs-12">{formik.errors.product_multiplier || formik.errors.product_multiplier_type}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            <div className={`st-form st-form-with-label-left no-arrows d-flex flex-wrap align-items-center ${((formik.touched.credit_card_fee || formik.touched.credit_card_fee_type) && (formik.errors.credit_card_fee || formik.errors.credit_card_fee_type)) ? "has-msg msg-error" : ""}`}>
                <label>
                    Credit Card Fee
                    <span className="required">*</span>
                </label>

                <div className="media-body st-form-input-container">
                    <div className="st-form-inline-input-select position-relative no-min-width mb-0 d-flex align-items-center">
                        <input
                            type="number"
                            className="st-fs-15"
                            placeholder="0"
                            id="credit_card_fee"
                            name="credit_card_fee"
                            {...formik.getFieldProps('credit_card_fee')}

                        />
                        <select
                            // value={mT}
                            id="credit_card_fee_type"
                            name="credit_card_fee_type"
                            {...formik.getFieldProps('credit_card_fee_type')}

                        >
                            <option value="fixed">$</option>
                            <option value="percent">%</option>
                        </select>
                        {
                            ((formik.touched.credit_card_fee || formik.touched.credit_card_fee_type) && (formik.errors.brand_multiplier || formik.errors.credit_card_fee_type)) && (
                                <div className="st-form-msg position-absolute">
                                    <p className="st-fs-12">{formik.errors.credit_card_fee || formik.errors.credit_card_fee_type}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            {show && <div className={`st-form st-form-with-label-left no-arrows d-flex flex-wrap align-items-center ${((formik.touched.multiplier || formik.touched.multiplier_type) && (formik.errors.multiplier || formik.errors.multiplier_type)) ? "has-msg msg-error" : ""}`}>
                <label>
                    Add new multiplier
                </label>

                <div className="media-body st-form-input-container d-flex justify-content-end">
                    <input
                        type="number"
                        className="st-fs-15 input-multiplier-store"
                        placeholder="Title"
                        id="multiplier_name"
                        name="multiplier_name"
                        {...formik.getFieldProps('multiplier_name')}

                    />

                    <div className="st-form-inline-input-select position-relative mb-0 d-flex align-items-center width-auto">
                        <input
                            type="number"
                            className="st-fs-15"
                            placeholder="0"
                            id="multiplier"
                            name="multiplier"
                            {...formik.getFieldProps('multiplier')}
                        />
                        <select
                            className=""
                            id="multiplier_type"
                            name="multiplier_type"
                            {...formik.getFieldProps('multiplier_type')}
                        >
                            <option value="fixed">$</option>
                            <option value="percent">%</option>
                        </select>
                        {
                            ((formik.touched.multiplier || formik.touched.multiplier_type) && (formik.errors.multiplier || formik.errors.multiplier_type)) && (
                                <div className="st-form-msg position-absolute">
                                    <p className="st-fs-12">{formik.errors.multiplier || formik.errors.multiplier_type}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            }
        </React.Fragment>
    )
}

export default memo(FormStoreMultiplier)